<template>
    <div class="siteFooter">
        <div class="mainContainer clearfix">
            <div class="footerLogo">
                <div class="bowyunLogo">
                    <img src="../assets/889副本.png" alt="">
                </div>
                <div class="aisLogo">
                    <img src="../assets/aisLogo.png" alt="">
                </div>
            </div>
            <div class="tailContainer">
                <div class="footerInfo">
                    <ul>
                        <li><router-link to="/SmartCloud">Smart云平台</router-link></li>
                        <li><router-link to="/Product/Parking">智慧停车</router-link></li>
                        <li><router-link to="/Product/Charging">智慧充电</router-link></li>
                        <li><router-link to="/Product/Community">智慧社区</router-link></li>

                    </ul>
                    <ul>
                        <li><router-link to="/Solution">解决方案 </router-link></li>
                        <li><router-link to="/Cases"> 应用案例 </router-link></li>
                        <li><router-link to="/Service"> 服务与支持</router-link></li>
                        <li></li>
                    </ul>
                    <ul>
                        <li><router-link to="/About"> 关于我们 </router-link></li>
                        <li>咨询电话：13618609409</li>
                        <li>qq:2051231045</li>
                        <li></li>
                    </ul>
                    <ul>
                        <li>车场用户关注</li>
                        <div class="QRCode"><img src="../assets/bowyun.jpg" alt=""></div>
                    </ul>
                    <ul>
                        <li>车主用户关注</li>
                        <div class="QRCode"><img src="../assets/ais.jpg" alt=""></div>
                    </ul>
                </div>
                <div>
                    <div class="tailInfo">
                        <p>地址：武汉.东西湖宏图大道汇悦城3-15</p>
                    </div>
                    <div class="tailInfo">版权所有：Copyright2025©武汉君泊天下网络科技有限公司</div>
                    <div class="tailInfo"><a href="https://beian.miit.gov.cn/#/Integrated/index">鄂ICP备2021006770号-2</a>
                    </div>
                </div>
            </div>

        </div>
        <ul class="friendShipLink">
            <li class="link"><p>友情链接：</p></li>
            <li><a href="https://tech.china.com/">中华网</a></li>
            <li><a href="http://www.cps.com.cn/">中安网</a></li>
            <li><a href="https://www.afzhan.com/">中国智慧城市网</a></li>
            <li><a href="https://www.8manage.cn/">项目管理软件</a></li>
            <li><a href="https://tool.chinaz.com/">站长之家</a></li>
            <li><a href="https://www.app17.com/">工业仪器网</a></li>
            <li><a href="http://www.chinaparking.org">停车网</a></li>
        </ul>
    </div>
</template>
<style scoped>
ul,
a {
    list-style: none;
    text-decoration: none;
    margin: 0;
    padding: 0;
    color: aliceblue;
}

.siteFooter {
    width: 100%;
    height: 455px;
    background: #000000;
    position: relative;
    /* border: 1px solid red;
    display: flex; */
}

.mainContainer {
    /* border: 1px solid red; */
    display: flex;
    margin-left: 20%;
    position: absolute;
    top: 30px;
}

.clearfix::after {
    content: "";
    display: table;
    clear: both;
}

.tailContainer {
    margin-left: 238px;
}

.footerLogo {
    display: flex;
    /* border: 1px solid red; */
}

.bowyunLogo {
    width: 160px;
    height: 57px;
    /* border: 1px solid rgb(252, 248, 248); */
}

.aisLogo {
    width: 100px;
    height: 57px;
    border: 5px solid rgb(251, 248, 248);
    border-top: black;
    border-right: #000000;
    border-bottom: #000000;
}

.footerInfo {
    display: flex;
    /* border: 1px solid red; */
}

img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

ul {
    /* width: 600px;
    height: 400px; */
    /* border: 1px solid yellow; */
    text-align: left;
}

li {
    width: 280px;
    height: 45px;
    /* border: 1px solid white; */
    font-size: 23px;
    color: aliceblue;
    line-height: 45px;
    /* align-items: center; */
}

.QRCode {
    width: 133px;
    height: 133px;
    /* border: 1px solid white; */
}

.tailInfo {
    width: 680px;
    height: 45px;
    /* border: 1px solid white; */
    font-size: 23px;
    color: aliceblue;
    line-height: 45px;
    text-align: left;
}

.friendShipLink {
    position: absolute;
    bottom: 20px;
    display: flex;
    margin-left: 15%;
    text-align: center;
    
}
.friendShipLink .link {
    color: rgba(170, 171, 170, 0.847);
}
.friendShipLink a {
    color: rgba(170, 171, 170, 0.847);
}
</style>